import type { IntervalJSON } from '@highimpact-frontend/api-types';
import type { DecimationPolicy } from '@highimpact/react-hooks';
import type { ThresholdRequestContextPrefs } from '@highimpact/scatterplot';

export interface MeasureRequestSignatureInput {
  intervals: IntervalJSON[];
  dataSources: unknown;
  measures: unknown;
  thresholdRequest?: ThresholdRequestContextPrefs;
  decimation?: DecimationPolicy;
  contextIndexToName?: unknown;
  pipeline?: unknown;
}

/**
 * Stable signature for measure API requests in scatter/timeseries/table widgets.
 *
 * Any change to sources, intervals, threshold context, column naming, or
 * pipeline must trigger a fresh fetch.
 */
export function buildMeasureRequestSignature(
  input: MeasureRequestSignatureInput
): string {
  return JSON.stringify({
    intervals: input.intervals,
    dataSources: input.dataSources,
    measures: input.measures,
    thresholdRequest: input.thresholdRequest ?? null,
    decimation: input.decimation ?? null,
    contextIndexToName: input.contextIndexToName ?? null,
    pipeline: input.pipeline ?? null,
  });
}
